import { UiDatepicker, UiSelect } from "@/components/ui";
import { CommandeStatusOptions } from "@/composables/commande";
import { format } from "date-fns";
import { useEffect, useState } from "react";

export type CommandeFilterDataModel = {
  status: string;
  creationDate: string;
  dfs: string;
  shelve?: string;
};

interface CommandeFilterFormProps {
  defaultValue: CommandeFilterDataModel;
  onChange?: ({
    status,
    creationDate,
    dfs,
    shelve,
  }: CommandeFilterDataModel) => void;
}

export function CommandeFilterForm({
  onChange,
  defaultValue,
}: CommandeFilterFormProps) {
  const [typeValue, setTypeValue] = useState<string>(defaultValue.status);
  const [shelve, setShelve] = useState<string>(defaultValue.shelve || "");
  const [creationDate, setCreationDate] = useState<string>(
    defaultValue.creationDate
  );

  const [dfs, setDfs] = useState<string>(defaultValue.dfs);

  useEffect(() => {
    if (onChange) onChange({ status: typeValue, creationDate, dfs, shelve });
  }, [typeValue, creationDate, dfs, shelve]);

  return (
    <div className="flex gap-2">
      <UiSelect
        options={CommandeStatusOptions}
        defaultValue={defaultValue.status}
        label="Statut"
        groupClassname="flex flex-col gap-1"
        placeholder="Choisissez un statut"
        onChange={(value) => setTypeValue(value)}
      ></UiSelect>

      <UiDatepicker
        name="dfs"
        className="w-full"
        groupClassname="flex flex-col gap-1"
        label="Date de création"
        placeholder="Date de création"
        onChange={(v: Date | null) => {
          setCreationDate(v ? format(v, "yyyy-MM-dd") : "");
        }}
        onClean={(e: React.MouseEvent) => setCreationDate("")}
      />

      <UiDatepicker
        name="creationDate"
        className="w-full"
        groupClassname="flex flex-col gap-1"
        label="Date de fabrication souhaitée"
        placeholder="Date de fabrication souhaitée"
        onChange={(v: Date | null) => {
          setDfs(v ? format(v, "yyyy-MM-dd") : "");
        }}
        onClean={(e: React.MouseEvent) => setDfs("")}
      />
    </div>
  );
}
